// import Vue from 'vue'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
import { signIn } from './login'

Toast.allowMultiple()
// Vue.use(Toast)
// Vue.use(Dialog)
export function strNumberToBusinessType(num) {
  let btArr = ['立即支付', '再次购买', '下载卡密', '确认收货', '立即激活']
  return btArr[num]
}
export default {
  install(Vue) {
    // 获取URL参数指定值
    Vue.prototype.$getUrlCode = function (code) {
      const search = window.location.search.substr(1)
      const rag = RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
      const result = search.match(rag)
      return result ? result[2] : null
    }
    // 获取服务器时间
    Vue.prototype.$getTime = function () {
      return new Promise((resolve, reject) => {
        this.$service.getTimestamp().then((res) => {
          resolve(res.data)
        })
      })
    }
    // 设备扫一扫
    // Vue.prototype.$deviceScan = function (name) {
    //   return new Promise((resolve) => {
    //     wx.scanQRCode({
    //       needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //       scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
    //       success: (res) => {
    //         // const resultStr = 'http://xxx.coocaa.com:9090/scan-in-equipment?unionCode=1252795840042684416_202004'.split('?')[1]
    //         const resultStr = res.resultStr.split('?')[1]
    //         if (!resultStr) {
    //           Toast('设备不合法,请重新扫码')
    //           return false
    //         }
            // const rag = RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
            // const unionCode = resultStr.match(rag)
            // if (unionCode) {
            //   // resolve(unionCode[2])
            //   this.$service
            //     .deviceBind({
            //       unionCode: unionCode[2]
            //     })
            //     .then((res) => {
            //       if (res.code === 200) {
            //         this.$router.push({
            //           name: 'edit-user-info',
            //           query: {
            //             model: res.data.model,
            //             chip: res.data.chip,
            //             openid: res.data.openId
            //           }
            //         })
            //       } else {
            //         Toast(res.message)
            //       }
            //     })
            // } else {
            //   Toast('扫码失败')
            // }
    //       }
    //     })
    //     wx.error((res) => {
    //       Toast('扫码失败')
    //     })
    //   })
    // }

    // 调用微信SDK
    Vue.prototype.$wxSdk = function ({ title, desc, link, imgUrl }) {
      return new Promise((resolve, reject) => {
        wx.error((res) => {
          reject(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
        wx.ready((res) => {
          resolve(res)
          var shareData = {
            title: title || '', // 分享标题
            desc: desc || '', // 分享描述
            link: link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl || '', // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: (e) => {
              // 用户确认分享后执行的回调函数
              console.log('success share: ', e)
            },
            cancel: (e) => {
              // 用户取消分享后执行的回调函数
              console.log('cancel share: ', e)
            }
          }
          wx.onMenuShareTimeline(shareData)
          wx.onMenuShareAppMessage(shareData)
        })
      })
    }
    // 获取客户端类型
    Vue.prototype.$getBrowser = function () {
      const userAgent = window.navigator.userAgent
      if (/MicroMessenger/.test(userAgent)) {
        return 'weixin'
      } else if (/AlipayClient/.test(userAgent)) {
        return 'alipay'
      } else {
        return 'other'
      }
    }
    // 帐号登录
    Vue.prototype.$signIn = signIn

    // 设置cookie
    Vue.prototype.$setCookie = function (cname, cvalue, exdays) {
      if (exdays) {
        var d = new Date()
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
        var expires = 'expires=' + d.toUTCString()
      }
      document.cookie = cname + '=' + cvalue + '; path=/;' + expires
    }
    // 获取cookie
    Vue.prototype.$getCookie = function (cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      // console.log(ca)
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return null
    }
  }
}
